import { render, staticRenderFns } from "./MedecinControle.vue?vue&type=template&id=6723c3be"
import script from "./MedecinControle.vue?vue&type=script&lang=js"
export * from "./MedecinControle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports